export default __webpack_public_path__ + "85235860e4583fe160d20438ca9f1ec1.jpg";